import React from 'react'
import { Flex } from 'antd'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { isNumber } from 'lodash'
import CategoriesList from '../../../questions/category/CategoriesList'
import EditCategoryDrawer from '../../../questions/category/edit/EditCategoryDrawer'
import CreateCategoryDrawer from '../../../questions/category/create/CreateCategoryDrawer'
import rubricSelectors from '../../../../../../store/selectors/rubric.selectors'
import { useFetchRubricsQuery } from '../../../../../../store/apis/rubric.api'
import { fetchRubricsSelectors } from '../../../../../../store/apis/utils/selectors/rubric.api.selectors'

const RubricCategoriesTab = () => {
    const { token } = useParams()
    const editingRubricId = useSelector(rubricSelectors.editingRubricId)
    const editingCategoryId = useSelector(rubricSelectors.editingCategoryId)
    const showCreateCategoryDrawer = useSelector(rubricSelectors.showCreateCategoryDrawer)

    const { data: rubric } = useFetchRubricsQuery({ token }, {
        skip: !isNumber(editingRubricId),
        selectFromResult: result => fetchRubricsSelectors.byId({ id: editingRubricId }, result),
    })

    return (
        <Flex vertical>
            <CategoriesList categories={rubric?.categories} rubricId={editingRubricId} />
            {isNumber(editingCategoryId) && <EditCategoryDrawer />}
            {showCreateCategoryDrawer && <CreateCategoryDrawer />}
        </Flex>
    )
}

export default RubricCategoriesTab
